"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.virtualCategoriesApi = exports.entityTagsApi = exports.eventProbabilitiesApi = exports.matchPhasesApi = exports.systemCurrenciesApi = exports.marketGroupsApi = exports.marketCategoriesApi = exports.currenciesApi = exports.marketsApi = exports.outcomeCategoriesApi = exports.sportApi = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const index_1 = require("../../index");
const sportApi = () => index_1.ApiManager.getApi(betweb_openapi_axios_1.SportsApi);
exports.sportApi = sportApi;
const outcomeCategoriesApi = () => index_1.ApiManager.getApi(betweb_openapi_axios_1.OutcomeCategoriesApi);
exports.outcomeCategoriesApi = outcomeCategoriesApi;
const marketsApi = () => index_1.ApiManager.getApi(betweb_openapi_axios_1.MarketsApi);
exports.marketsApi = marketsApi;
const currenciesApi = () => index_1.ApiManager.getApi(betweb_openapi_axios_1.CurrenciesApi);
exports.currenciesApi = currenciesApi;
const marketCategoriesApi = () => index_1.ApiManager.getApi(betweb_openapi_axios_1.MarketCategoriesApi);
exports.marketCategoriesApi = marketCategoriesApi;
const marketGroupsApi = () => index_1.ApiManager.getApi(betweb_openapi_axios_1.MarketGroupsApi);
exports.marketGroupsApi = marketGroupsApi;
const systemCurrenciesApi = () => index_1.ApiManager.getApi(betweb_openapi_axios_1.SystemCurrenciesApi);
exports.systemCurrenciesApi = systemCurrenciesApi;
const matchPhasesApi = () => index_1.ApiManager.getApi(betweb_openapi_axios_1.MatchPhasesApi);
exports.matchPhasesApi = matchPhasesApi;
const eventProbabilitiesApi = () => index_1.ApiManager.getApi(betweb_openapi_axios_1.EventProbabilitiesApi);
exports.eventProbabilitiesApi = eventProbabilitiesApi;
const entityTagsApi = () => index_1.ApiManager.getApi(betweb_openapi_axios_1.EntityTagsApi);
exports.entityTagsApi = entityTagsApi;
const virtualCategoriesApi = () => index_1.ApiManager.getApi(betweb_openapi_axios_1.VirtualCategoriesApi);
exports.virtualCategoriesApi = virtualCategoriesApi;
//# sourceMappingURL=apis.js.map